// Location variations that we want to remove from the location name based
// on all the types sent by the providers and mapped in
// app/assets/javascripts/react/shared/components/DesignSystem/Inputs/InputLocation/utils/locationTypes.js
export const LOCATION_VARIATIONS = [
  'Street',
  'Intersection',
  'Region',
  'Country',
  'State/Province',
  'County',
  'District',
  'Township',
  'Village',
  'Area',
  'City',
  'Ward',
  'Neighborhood',
  'Building',
  'Postal Code',
  'Natural Feature',
  'Airport',
  'Park',
  'Point of Interest',
  'Town',
  'Establishment',
  'Doctor',
] as const;

// Since all the location types are sent by the providers and appended in " (Location Type)",
// we are mapping all the variations to a regex pattern to remove them from the location name
export const LOCATION_VARIATIONS_PATTERN = LOCATION_VARIATIONS.map((type) =>
  type.replace(/[/\\^$*+?.()|[\]{}]/g, '\\$&'),
).join('|');

// Valid location levels that match the backend DTO::Common::Location TypeEnum
export const VALID_LOCATION_LEVELS = [
  'administrative_area_level_1',
  'administrative_area_level_2',
  'administrative_area_level_3',
  'administrative_area_level_4',
  'administrative_area_level_5',
  'airport',
  'colloquial_area',
  'country',
  'establishment',
  'intersection',
  'locality',
  'natural_feature',
  'neighborhood',
  'park',
  'plus_code',
  'point_of_interest',
  'political',
  'postal_code',
  'premise',
  'route',
  'street_address',
  'street_number',
  'sublocality_level_1',
  'sublocality_level_2',
  'sublocality_level_3',
  'sublocality_level_4',
  'sublocality_level_5',
  'sublocality',
  'subpremise',
] as const;
